var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.563,
    height: 14.912,
    viewBox: "0 0 16.563 14.912",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "export",
    transform: "translate(-1 -0.992)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M14.8,24.417H3.761A2.761,2.761,0,0,1,1,21.656v-1.1a.552.552,0,1,1,1.1,0v1.1a1.656,1.656,0,0,0,1.656,1.656H14.8a1.656,1.656,0,0,0,1.656-1.656v-1.1a.552.552,0,1,1,1.1,0v1.1A2.761,2.761,0,0,1,14.8,24.417Z",
    transform: "translate(0 -8.514)",
    fill: "#2d5794"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M16.282,6.361H13.963a2.358,2.358,0,0,1-2.429-2.44V1.552a1.684,1.684,0,0,1,.1-.552H9.325A1.336,1.336,0,0,0,8,2.342V11.8a1.336,1.336,0,0,0,1.325,1.342h6.184A1.336,1.336,0,0,0,16.834,11.8V6.284A1.656,1.656,0,0,1,16.282,6.361ZM13.913,8.57a.552.552,0,0,1-.784,0l-.16-.166v1.982a.552.552,0,0,1-1.1,0V8.4l-.16.166a.554.554,0,0,1-.784-.784l1.1-1.1a.571.571,0,0,1,.784,0l1.1,1.1a.552.552,0,0,1,0,.784Z",
    transform: "translate(-3.135 -0.004)",
    fill: "#2d5794"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M20.433,4.309,17.341,1.162a.547.547,0,0,0-.944.386V3.917a1.248,1.248,0,0,0,1.325,1.336h2.319a.552.552,0,0,0,.392-.944Z",
    transform: "translate(-6.895)",
    fill: "#2d5794"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.df04500e90dcc7fb0a78ad3ebe521856.svg";
export { ForwardRef as ReactComponent };